<div class="page" [ngClass]="setIntelDisplayOneFont ? 'intelOne-display':'latin-bold'">
  <!-- HERO -->
  <div class="hero" role="region" [ngClass]="(ptlType === 'PANTHER_LAKE') ? 'ptl-wc-border':'ptl-12xe-wc-border'" aria-label="Welcome card" *ngIf="['en-us', 'es-mx', 'fr'].includes(language)">
    <!-- <div class="orb" aria-hidden="true"></div> -->
  
    <div class="title-wrap">
      <div class="title-heading">
         <img [src]="ptlVAHomePageText?.ptl_homePage_icon" class="home-page-gif" alt="animation" />
        <div class="home-page-wc-text" [ngClass]="ptlType=='PANTHER_LAKE' ? 'black-font' : 'white-font'">
          <h1 [innerHtml]="ptlVAHomePageText?.tr_VAHeading"></h1>
          <p [innerHtml]="ptlVAHomePageText?.tr_VASubHeading"></p>
        </div>
      </div>
  
      <div class="search-container">
        <input type="search" placeholder="{{ptlVAHomePageText?.tr_VAInputboxQuestion}}"
          aria-label="Ask me about this device" />
        <div class="search-send-img" [ngClass]="ptlType === 'PANTHER_LAKE_12XE' ? 'ptl12xe-search-icon' : 'ptl-search-icon'" (click)="routeToTab('va')">
          <img [src]="vaSearchSendIcon" alt="search icon"/>
        </div>
      </div>
    </div>
  </div>

  <div [innerHtml]="ptlHomePageText" class="hero-title" [ngClass]="[ptlType=='PANTHER_LAKE' ? 'black-font ptl-hero-title-padding' : 'white-font',setIntelDisplayOneFont ? 'intelOne-headline':'']"></div>

  <div class="split-card" (click)="routeToTileDetailsPage(overviewLibraryContent[0]?.tileUrlName)" [ngClass]="ptlType=='PANTHER_LAKE' ? 'ptl-split-card-bg' : 'ptl12xe-split-card-bg'" role="article" aria-label="Feature">
    <div class="left" aria-hidden="true" style="background-image: url({{overviewLibraryContent[0]?.tileBadgeUrl}});"></div>
    <div class="right">
      <p [innerHtml]="overviewLibraryContent[0]?.tr_tileTitle"></p>
    </div>
  </div>

  <div class="grid" role="list">
    <div *ngFor="let tile of overviewLibraryContent | slice:1:8">
      <div *ngIf="tile?.tileUrlName !== 'ptl-evo'" (click)="routeToTileDetailsPage(tile.tileUrlName)" class="card-item card-yellow" role="listitem" [ngClass]="{
    'ai-experience-tile': tile?.tileUrlName === 'ptl-aiexperience', 'design-tile-border': tile.tileUrlName === 'ptl-design'}">
        <div class="tile-background-image" style="background-image: url({{tile?.tileBadgeUrl}});"></div>
        <p [innerHtml]="tile?.tr_tileTitle" class="tile-text" [ngClass]="((ptlType=='PANTHER_LAKE' && (tile.tileUrlName == 'ptl-performance')) ? 'black-font' : 'white-font')"></p>
      </div>
    </div>
  </div>

</div>
